import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import APH from './APH';

const APHWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'APH',
            }}
        >
            <APH />
        </ServicesChartsDataProvider>
    );
};

export default APHWrapper;
